// @flow

import { observer } from "mobx-react";
import React from "react";

import UserStore from "app/stores/UserStore";

import "./CreateStory.scss";

type Props = {
    text?: string,
    icon?: string,
    url: string
};

@observer
export default class CreateStory extends React.Component<Props> {
    handleClick = (event: Event) => {
        event.preventDefault();

        const url = `/video/annotate/${this.props.url}`;
        if (UserStore.hasEarlyAccess) {
            window.location.href = url;
        } else {
            window.location.href = "/sign-up";
        }
    };

    render() {
        const text = this.props.text || "Create your own video story!";
        const icon = this.props.icon || "check";

        return (
            <div className="CreateStory">
                <button
                    className="CreateStory__button"
                    onClick={this.handleClick}
                >
                    <i className={`fa fa-${icon}`} /> {text}
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/CreateStory/CreateStory.js